<template>
  <div class="price-item">
    <div class="theader">
      <div class="cell">名称</div>
      <div class="cell flex-center">{{ chargeType===1?unitName:'数量' }}</div>
      <div class="cell fr">价格(元)</div>
    </div>
    <div class="tline" v-for="priceItem of list" :key="priceItem.id">
      <!-- v-for="priceItem of getOrderList(list || [])" -->
      <div class="cell">
        <div class="van-ellipsis">{{ priceItem.priceName }}</div>
      </div>
      <div class="cell flex-center">
        <div class="van-ellipsis">{{ priceItem.priceNum }}{{priceItem.dayType===2?'月':unitName}}</div>
      </div>
      <div class="cell fr">
        <div class="van-ellipsis">{{ priceItem.price | formatNumber }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import x3TagDay from '@x3/common/tag/x3-tag-day.vue';
export default {
  name: 'course-price',
  components: {
    x3TagDay,
  },
  props: {
    list: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    chargeType: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      
    }
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    unitName() {
      if (this.chargeType == 1) {
        return this.lessonUnit;
      } else {
        return '天'
      }
    }
  },
  methods: {
    // // 将单价排在前面
    // getOrderList(list) {
    //   let newList = JSON.parse(JSON.stringify(list));
    //   return newList.sort((a, b) => b.originalPrice - a.originalPrice);
    // },
  },
};
</script>

<style lang="scss" scoped>
.price-item {
  background: var(--white);
  position: relative;
  border-radius: calc(var(--gap) * 4);
  overflow: hidden;
  border: 1px solid rgba(0, 184, 255, 0.08);;
  
  .theader,
  .tline {
    display: flex;
    align-items: center;
    color: var(--g7);
    padding: calc(var(--gap) * 8) calc(var(--gap) * 12);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    .cell {
      flex: 2;
      overflow: hidden;
      &:first-child {
        padding: 0 0 0 calc(var(--gap) * 4);
        flex: 3;
      }
      &.fr {
        text-align: right;
      }
    }
  }
  .theader {
    color: var(--g6);
    background: rgba(0, 184, 255, 0.08);
    height: 44px;
  }
  // .tline {
  //   &:nth-child(even) {
  //     background-color: rgba(var(--g1-rgb), 0.8);
  //   }
  // }
}
</style>